// Porta leve para `src/app` e `src/routes` (JS inicial): manifesto, schema de busca e catálogo.
import './billing-product.catalog';

export { billingProductScreen } from './billing-product.screen';
export { BILLING_PRODUCT_PATH, billingProductSearch, COSTS_TAB, LEGACY_TAB_PATHS, type BillingProductSearch } from './billing-product.search';

/** A tela, carregada sob demanda pela rota. */
export const loadBillingProductScreens = () => import('./billing-product-hub');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadBillingProductGuides = () => import('./billing-product.guide');
